import type { ReactNode } from 'react';
import { RouterProvider } from 'react-aria-components';
import { useHref, useNavigate } from 'react-router-dom';

const ABSOLUTE_URL = /^[a-z][a-z\d+.-]*:/i;

/** react-router's `useHref`, except an absolute URL (another host) is kept as is; React Aria then navigates to it natively. */
function useRouterHref(href: string): string {
  const resolved = useHref(href);
  return ABSOLUTE_URL.test(href) ? href : resolved;
}

/** Lets React Aria links (`LinkButton`) navigate through react-router instead of a full page load. Router context only. */
export function RouterBridge({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  return (
    <RouterProvider navigate={navigate} useHref={useRouterHref}>
      {children}
    </RouterProvider>
  );
}
